export function getMinDepositAmountInCents() {
  return 2000
}

export function getMinWithdrawAmountInCents() {
  return 2000
}
